import Inputmask from 'inputmask';
import manager from 'app/module46/component-manager.js';

/**
	Récupère tous les champs et applique le masque s'il y a lieu.

	Alias de base: email, currency, decimal, integer, date, datetime, dd/mm/yyyy

	i.e.:
		<input type="tel" data-inputmask-alias="phone"/>
		<input type="text" data-inputmask-alias="email"/>
		<input type="text" data-inputmask-alias="currency"/>

	@see https://github.com/RobinHerbots/Inputmask
*/
manager.plugin('inputmasks', (target) => {

	Inputmask.extendDefaults({
		autoUnmask: true,
		removeMaskOnSubmit: true,
	});

	Inputmask.extendAliases({
		// Dépend du pays...
		// postal: { mask: 'A9A 9A9' }, 
		phone: { mask: '[9 ]{0,1}(999) 999-9999', numericInput: true },
		// Cause une erreur, car le type email ne supporte pas la sélection...
		//email: { supportsInputType: ['email'] } 
		'currency-cad': {
			suffix: ' $',
			groupSeparator: '',
			radixPoint: '.',
			alias: 'numeric',
			placeholder: '0',
			autoGroup: true,
			digits: 2,
			digitsOptional: false,
			clearMaskOnLostFocus: false,
			autoUnmask: true,
			unmaskAsNumber: true
		},
		'currency-usd': {
			alias: 'currency',
		}
	})

	Inputmask().mask(
		target.querySelectorAll('input')
	);
});